import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getAppTimerMessages, loadAppTimerMessages } from "../app/store/messages";
import { getComponentUserStatus, UpdateComponentsUserStatus } from "../app/store/tools";
import { getCurrentUser } from "../app/store/auth";

const TIMER_POPUP_STYLES = {
  modalContent: {
    borderRadius: "0px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
      borderBottom: "1px solid #e2e8f0",
    color: "#0f172a",
    fontSize: "21px",
    boxShadow: "none",
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: 0,
    fontWeight: "normal"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  helperCard: {
    borderRadius: "0px",
    padding: "16px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  tableCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },
  table: {
    margin: 0,
    minWidth: "760px",
  },
  tableToolbar: {
    padding: "16px 18px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
  },
  tableTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#0f172a",
    margin: 0,
  },
  tableSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  tableHeader: {
    background: "#f8fbff",
    borderBottom: "1px solid #e2e8f0",
  },
  headerCell: {
    fontSize: "11px",
    fontWeight: 600,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    padding: "14px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
  },
  rowCell: {
    fontSize: "13.5px",
    color: "#1e293b",
    padding: "16px 20px",
    verticalAlign: "middle",
  },
  indexCell: {
    fontWeight: 600,
    color: "#94a3b8",
    width: "50px",
  },
  dateCell: {
    fontWeight: 600,
    color: "#2563eb",
    width: "200px",
  },
  messageCell: {
    whiteSpace: "pre-wrap",
    lineHeight: "1.6",
  },
  datePill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 11px",
    fontSize: "12px",
    fontWeight: 600,
  },
  messageBox: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "12px 14px",
  },
  emptyState: {
    padding: "38px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "13px",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  closeActionBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

const TimerPopup = ({ timerShowHide, handleTimerModalShowHide, workflowTask }) => {
  const [tmrMessages, setTmrMessages] = useState([]);

  const appTimerMessagesSelector = useSelector(getAppTimerMessages);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (workflowTask?.ciid > 0)
      dispatch(loadAppTimerMessages(workflowTask.ciid))
  }, [workflowTask]);

  useEffect(() => {
    setTmrMessages(appTimerMessagesSelector);
    if (appTimerMessagesSelector.length > 0) {
      let tmItems = "";
      appTimerMessagesSelector.map((x, key) => {
        if (key > 0) tmItems += ",";
        tmItems += x.tiid;
      });
      handleUpdateComponent(tmItems, workflowTask.ciid);
    }
  }, [appTimerMessagesSelector])

  const handleUpdateComponent = (compItems, ciid) => {
    const comp = componentUserStatusSelector.filter(x => x.compId === 27);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Insurance Expiry",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 27
    }
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  }


  return (
    <Modal
      show={timerShowHide}
      size="xl"
      centered
      onHide={handleTimerModalShowHide}
      dialogClassName="timer-popup-modal-dialog"
      contentClassName="timer-popup-modal-content"
    >
      <style>
        {`
          .timer-popup-modal-dialog {
            max-width: ${TIMER_POPUP_STYLES.modalDialog.maxWidth};
          }
          .timer-popup-modal-content {
            border-radius: ${TIMER_POPUP_STYLES.modalContent.borderRadius};
            overflow: ${TIMER_POPUP_STYLES.modalContent.overflow};
            border: ${TIMER_POPUP_STYLES.modalContent.border};
            box-shadow: ${TIMER_POPUP_STYLES.modalContent.boxShadow};
          }
          .timer-popup-table tbody tr:hover {
            background-color: #fbfdff;
          }
        `}
      </style>

      <Modal.Header style={TIMER_POPUP_STYLES.modalHeader}>
        <div style={TIMER_POPUP_STYLES.headerContent}>
          <Modal.Title as="div" style={TIMER_POPUP_STYLES.titleWrap}>
            <div style={TIMER_POPUP_STYLES.headerIcon}>
              <i className="fa fa-clock-o" aria-hidden="true"></i>
            </div>
            <div>
              <div style={TIMER_POPUP_STYLES.title}>Timer Notifications</div>
              <div style={TIMER_POPUP_STYLES.subtitle}>
                Upcoming deadlines and scheduled alerts for this application.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={TIMER_POPUP_STYLES.closeButton}
            onClick={handleTimerModalShowHide}
            aria-label="Close timer notifications"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={TIMER_POPUP_STYLES.modalBody}>
        <div style={TIMER_POPUP_STYLES.helperCard}>
          <div style={TIMER_POPUP_STYLES.helperTitle}>Notification guidance</div>
          <p style={TIMER_POPUP_STYLES.helperText}>
            These reminders highlight upcoming insurance expiration activity and scheduled alerts related to this application.
          </p>
        </div>

        <div style={TIMER_POPUP_STYLES.tableCard}>
          <div style={TIMER_POPUP_STYLES.tableToolbar}>
            <div style={TIMER_POPUP_STYLES.tableTitle}>Scheduled Alerts</div>
            <div style={TIMER_POPUP_STYLES.tableSubtitle}>
              {tmrMessages.length} notification{tmrMessages.length === 1 ? "" : "s"} available
            </div>
          </div>
          <div className="table-responsive">
            <table className="table align-items-center table-hover timer-popup-table" style={TIMER_POPUP_STYLES.table}>
              <thead style={TIMER_POPUP_STYLES.tableHeader}>
                <tr>
                  <th style={TIMER_POPUP_STYLES.headerCell}>#</th>
                  <th style={TIMER_POPUP_STYLES.headerCell}>Due Date & Time</th>
                  <th style={TIMER_POPUP_STYLES.headerCell}>Alert Message</th>
                </tr>
              </thead>
              <tbody>
                {tmrMessages.length > 0 ? (
                  tmrMessages.map((item, index) => (
                    <tr key={index}>
                      <td style={{ ...TIMER_POPUP_STYLES.rowCell, ...TIMER_POPUP_STYLES.indexCell }}>
                        {index + 1}
                      </td>
                      <td style={{ ...TIMER_POPUP_STYLES.rowCell, ...TIMER_POPUP_STYLES.dateCell }}>
                        <span style={TIMER_POPUP_STYLES.datePill}>
                          <i className="fa fa-calendar-o" aria-hidden="true"></i>
                          <Moment format="MMM Do YYYY, h:mm a">
                            {item.endDateTime}
                          </Moment>
                        </span>
                      </td>
                      <td style={{ ...TIMER_POPUP_STYLES.rowCell, ...TIMER_POPUP_STYLES.messageCell }}>
                        <div style={TIMER_POPUP_STYLES.messageBox}>
                          {decodeURIComponent(item.message)}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={TIMER_POPUP_STYLES.emptyState}>
                      <i className="fa fa-clock-o fa-3x mb-3 d-block opacity-2"></i>
                      No active notifications found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>


      </Modal.Body>
      <Modal.Footer style={TIMER_POPUP_STYLES.modalFooter}>
        <div style={TIMER_POPUP_STYLES.footerActions}>
          <button
            type="button"
            style={TIMER_POPUP_STYLES.closeActionBtn}
            onClick={handleTimerModalShowHide}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};


export default TimerPopup;
